import { PersonalLoanStoreService } from '@hb/modules/financial-obligations/personal-loan/personal-loan-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAmountInputComponent } from '@ap/input/amount';
import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'personal-loan-amount',
    imports: [ApAmountInputComponent, ApContentPipe, ReactiveFormsModule, NextButtonComponent],
    templateUrl: './personal-loan-amount.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: PersonalLoanStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PERSONAL_LOAN_TOTAL_AMOUNT }
    ]
})
export class PersonalLoanAmountComponent extends GlobalInjectComponent<PersonalLoanStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(PersonalLoanStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getTotalAmount()?.amount.toString(),
            QuestionKey.PERSONAL_LOAN_TOTAL_AMOUNT
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setTotalAmount(amount));
    }
}
